module.exports = (__parcel__import__("1ZIH5")).then(() => parcelRequire('8OYBW'));